module.exports = __webpack_public_path__ + "footer-3-e88be5000a1508e9fc499edad7f48562.png";